import { render, staticRenderFns } from "./TheHeaderCustom.vue?vue&type=template&id=033cf6ea&"
import script from "./TheHeaderCustom.vue?vue&type=script&lang=js&"
export * from "./TheHeaderCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports